import React, { useMemo } from 'react';
import { TimeSignal } from 'graphql/types';
import { NotesListLabelGroup } from '../NotesListLabelGroup';
import { UNCATEGORIZED_GROUP_KEY } from './useGroupBy';

interface UseLabelGroupComponentsProps {
  groupedNotes: Record<string, TimeSignal[]>;
  groupDurations: Record<string, number>;
  groupedNotesExpansionState: Record<string, boolean>;
  expandAll: boolean;
  onExpandCollapse: (day: string) => void;
  day: string;
}

export const useLabelGroups = ({
  groupedNotes,
  groupDurations,
  groupedNotesExpansionState,
  expandAll,
  onExpandCollapse,
  day
}: UseLabelGroupComponentsProps): React.ReactNode => {
  return useMemo(() => {
    return Object.keys(groupedNotes).map((key: string) => {
      const isLabelGroupExpanded =
        groupedNotesExpansionState[key] === undefined
          ? expandAll
          : groupedNotesExpansionState[key];
      return (
        <NotesListLabelGroup
          key={key}
          day={day}
          groupIndex={key}
          expanded={isLabelGroupExpanded}
          onExpandCollapse={onExpandCollapse}
          notes={groupedNotes[key]}
          totalCount={groupedNotes[key].length}
          totalDuration={groupDurations[key]}
          isUncategorizedGroup={key.includes(UNCATEGORIZED_GROUP_KEY)}
        />
      );
    });
  }, [
    groupedNotes,
    groupedNotesExpansionState,
    expandAll,
    day,
    onExpandCollapse,
    groupDurations
  ]);
};
